import { Box, Flex, Text } from '@chakra-ui/react';
import { Button, useToast } from '@morressier/alembic';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getUserVerifyPrimaryEmail } from 'src/api/signUpMutation';
import { useKeycloak } from 'src/components/AuthHOC';
import SuccessModal from 'src/components/User/SuccessModal';
import { BrandLogo } from '../SignUpInviteSent';

const VerifyPrimaryEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const toast = useToast();
  const { logout } = useKeycloak();

  const [isVerifying, setIsVerifying] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  const handleVerifyEmail = async () => {
    if (!token || isVerifying) {
      return;
    }

    setIsVerifying(true);

    try {
      const data = await getUserVerifyPrimaryEmail(token);
      toast({
        variant: 'success',
        title: 'Email Verification Success',
        description: data?.message ?? 'Email verified successfully.',
        isClosable: true
      });
      setIsVerifying(false);
      setIsSuccessModalOpen(true);
    } catch (error) {
      const message =
        (error as { response?: { data?: { message?: string } } })?.response
          ?.data?.message || 'Something went wrong';

      toast({
        variant: 'error',
        title: 'Verification link error',
        description: message,
        isClosable: true
      });

      setIsVerifying(false);
    }
  };

  return (
    <Flex
      height="100%"
      flexGrow={2}
      flexBasis={0}
      minHeight={'100%'}
      direction="column"
    >
      <Flex
        flexDirection="column"
        gap={12}
        width={{ base: '95%', md: '80%' }}
        marginX={'auto'}
        flex={1}
      >
        <Flex justifyContent={'space-between'} alignItems={'end'}>
          <BrandLogo />
        </Flex>

        <Flex flex="1" alignItems="center" justifyContent="center" px={4}>
          <Box textAlign="center" maxW="640px" width="full">
            <Text textStyle="headingGroup">
              Verify your Primary email address
            </Text>
            <Text textStyle="textBody" mt={2}>
              Please verify your updated Primary email address
            </Text>
            <Button onClick={handleVerifyEmail} my={8} disabled={isVerifying}>
              {isVerifying ? 'Verifying...' : 'Verify Email'}
            </Button>
          </Box>
        </Flex>
      </Flex>

      <SuccessModal
        isOpen={isSuccessModalOpen}
        title="Email Verified"
        message="Your primary email address has been verified successfully. Please log in with new primary email"
        buttonLabel="Go To Login"
        onButtonClick={() => {
          logout();
        }}
      />
    </Flex>
  );
};

export default VerifyPrimaryEmail;
